<template>
  <nav id="menu">
    <a class="close-button" @click="closeMenu">Close</a>
    <div class="nav-wrapper">
      <p class="nav-label">Menu</p>
      <ul>
        <li class="nav-home" role="presentation"><router-link :to="{ name : 'index'}">Home</router-link></li>
        <li class="nav-archive" role="presentation"><router-link :to="{ name : 'archive'}">Archive</router-link></li>
        <li class="nav-search" role="presentation"><router-link :to="{ name : 'search'}">Search</router-link></li>
        <li class="nav-shares" role="presentation"><router-link :to="{ name : 'shares'}">Shares</router-link></li>
        <li class="nav-world-terrain-map" role="presentation"><router-link :to="{ name : 'world-terrain-map'}">World Terrain Map</router-link></li>
        <li class="nav-market" role="presentation"><router-link :to="{ name : 'market'}">Daily Market Report</router-link></li>
        <li class="nav-a-share-indicator" role="presentation"><router-link :to="{ name : 'a-share-market-cap-gdp'}">A-Share Market Cap / GDP</router-link></li>
        <!--<li class="nav-tags" role="presentation"><router-link :to="{ name : 'tag'}">Tags</router-link></li>-->
        <li class="nav-profile" role="presentation"><router-link :to="{ name: 'profile'}">profile</router-link></li>
<!--        <li class="nav-options" role="presentation"><router-link :to="{ name: 'options'}">Options</router-link></li>-->
        <li class="nav-feed" role="presentation"><a :href="siteurl+'/blog/feed'" target="_blank"><icon name="rss" scale="1" ></icon> subscribe</a></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'nav-fade',
  methods: {
    closeMenu () {
      document.querySelector('html').classList.remove('menu-active')
    }
  },
  mounted () {

  },
  computed: {
    siteurl: function () {
      return this.$store.state.baseUrl
    }
  },
  updated() {

  }
}
</script>

<style scoped>

</style>
